import React, { useContext, useEffect, useState } from 'react';
import { IonIcon, IonInput, IonItem, IonLabel, IonGrid, IonRow, IonCol, IonImg, IonModal, IonContent, IonFooter, IonToolbar, IonTitle, IonButton } from '@ionic/react';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Button, Header, Input } from 'components';
import { DielContext } from 'core/DielContext';
import { createUser, updateUser } from 'reducers/UserSlice';
import { FirebaseService } from 'services';
import { useAppDispatch, useAppSelector } from 'hooks';

const schema = yup.object().shape({
  address: yup.string().required(),
  city: yup.string().required(),
  province: yup.string().required(),
  zip: yup.string().required(),
}).required();

const defaultValues = {
  address: '',
  city: '',
  province: '',
  zip: '',
};

const Profile: React.FC = () => {
  const { currentUser } = FirebaseService.auth;
  const dispatch = useAppDispatch();
  const user: any = useAppSelector((state) => state.user);

  const { setOnboarded, showToast } = useContext(DielContext);
  const { control, formState, watch, reset } = useForm({
    mode: 'onChange',
    defaultValues,
    resolver: yupResolver(schema),
  });
  const { isValid } = formState;
  const form = watch();
  const [loading, setLoading] = useState(false);

  const handleSave= () => {
    setLoading(true);
    dispatch(updateUser(form))
      .then((action: any) => {
        setLoading(false);

        if (action.payload) {
          setOnboarded(true);
          showToast('Successfully updated');
        } else {
          showToast('Something went wrong');
        }
      });
  };

  useEffect(() => {
    if (user) reset(user);
  }, [user]);

  return (
    <div>
      <Header title="Address" showCart={false} showGoBack showMenu={false} />

      <div className="mainWrapper">
        <Controller
          name="address"
          control={control}
          render={({ field }) => (
            <Input
              label="Address"
              props={field}
              placeholder="Address"
            />
          )}
        />

        <Controller
          name="city"
          control={control}
          render={({ field }) => (
            <Input
              label="City"
              props={field}
              placeholder="City"
            />
          )}
        />

        <Controller
          name="province"
          control={control}
          render={({ field }) => (
            <Input
              label="Province"
              props={field}
              placeholder="Province"
            />
          )}
        />

        <Controller
          name="zip"
          control={control}
          render={({ field }) => (
            <Input
              label="Zip Code"
              props={field}
              placeholder="Zip Code"
            />
          )}
        />

        <IonFooter>
          <Button
            props={{ expand: 'full' }}
            label="Save"
            disabled={!isValid || loading}
            loading={loading}
            onClick={handleSave}
          />
        </IonFooter>
      </div>
    </div>
  );
};

export default Profile;
